
var PRC = {};

//PRC.endpoint_url = "https://walkingwithpurpose.com/parish-lookup-tool/index.php";

PRC.endpoint_url = "https://walkingwithpurpose.com/wp-json/wwp/v1/parishes";


PRC.active_request = false;
PRC.long_results = false;

PRC.last_search_term = false;

PRC.doParishSearch = function(e){
  	e.preventDefault();
  	$("#parish-search").removeClass('parish-search-selected');


	var zip_value = $(".parish-lookup-zip").val();
	var city_state_value = $(".parish-lookup-city-state").val();

	var target_url = false;
	if(zip_value){
		//target_url = PRC.endpoint_url + "?mode=zip&search=" + zip_value;
        target_url = PRC.endpoint_url + "?zip=" + zip_value;
	}
	else{
		//target_url = PRC.endpoint_url + "?mode=city&search=" + city_state_value;
        target_url = PRC.endpoint_url + "?city_state=" + city_state_value;
	}

	if(target_url == PRC.last_search_term){
		return;
	}
	PRC.last_search_term = target_url;

	if(PRC.active_request){
		PRC.active_request.abort();
	}

	$(".parish-results").html("<div><h4>Loading...</h4></div>");
	// return false;

	PRC.active_request = $.get(target_url, function(response){
		// console.log('rep', response);
		$(".parish-results").html("");
		$("#parish-name").val("");

		if(response.length == 0){
			$(".parish-results").append("<div><h4>No results found</h4></div>");
			return false;
		}

		result_html = "";

		if(response.length > 5){
			$(".parish-search-checkout-message").fadeIn();
			PRC.long_results = true;
		}
		else{
			$(".parish-search-checkout-message").fadeOut();
			PRC.long_results = false;
		}

		for(index in response){
			var row = response[index];

          	var name = row[0];
            var address = row[1] + ", " + row[2] + ", " + row[4] + ", " + row[5] + ", " + row[6];
            var sfid = row[7];

			result_html += "<div data-name=\"" + name + "\" data-address=\"" + address + "\" data-sfid=\"" + sfid + "\">";
				result_html += "<h4>";
				result_html +=  name;
				result_html += "</h4>";
				result_html += "<p>";
					result_html = result_html + address;
				result_html += "</p>";
			result_html += "</div>";
		}
		$(".parish-results").append(result_html);
	});


	return false;
};

PRC.handleParishClick = function(){
	$('.parish-results > div').removeClass('active');
	$(this).addClass('active');

	var name = $(this).attr('data-name');
	var address = $(this).attr('data-address');
	var sfid = $(this).attr('data-sfid');

	$("#parish-name").val(name);
	$("#parish-address").val(address);
	$("#parish-sfid").val(sfid);

  	$("#parish-search").addClass('parish-search-selected');
}

PRC.makeSearchActive = function(){
  	$("#parish-search").removeClass('parish-search-selected');
};

 $(document).on('keyup', '.parish-lookup-inputs input', PRC.doParishSearch);
 $(document).on('focus', '.parish-lookup-inputs input', PRC.makeSearchActive);


 $(document).on('click', '#parish-search', PRC.doParishSearch);
 $(document).on('click', '.parish-results > div', PRC.handleParishClick);

//  $(window).scroll(function(){
//  	var real_checkout_pos = $(".cart-bottom-main").position().top;
//  	var window_height = $(window).height();
//  	var target_scroll = $(window).scrollTop() + window_height;

//  	if(real_checkout_pos > target_scroll  && PRC.long_results){
// 		$(".parish-search-checkout-message").fadeIn('fast');
//  	}
//  	else{
// 		$(".parish-search-checkout-message").fadeOut('fast');
//  	}

//  	// console.log(real_checkout_pos,target_scroll,  $(window).scrollTop(), window_height );
//  });

